// Import 3rd-party dependencies
import { Component, Input, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';
import { timer } from 'rxjs';
import { SubSink } from 'subsink';

// Import project-specific dependencies
import { CHIP_COMPONENT_CONSTS } from '@app/config/constants';

export interface ChipContent {
  state: boolean;
  value: string;
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'hub-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.css']
})
export class ChipComponent implements OnInit, OnDestroy {
  private subs: SubSink;
  @Input() options: ChipContent[];
  @Input() clearSelected: boolean;
  @Output() selectedValues: EventEmitter<string[]>;
  selectedChips: string[];
  consts = CHIP_COMPONENT_CONSTS;

  constructor() {
    this.clearSelected = false;
  }

  ngOnInit(): void {
    this.subs = new SubSink();
    this.selectedChips = [];
    this.selectedValues = new EventEmitter<string[]>();
    this.setExistingValues();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  changeSelected(query: string): void {
    const index = this.selectedChips.indexOf(query);
    if (index >= 0) {
      this.selectedChips.splice(index, 1);
    } else {
      this.selectedChips.push(query);
    }
    this.selectedValues.emit(this.selectedChips);
  }

  clearAll(): ChipContent[] {
    this.options.forEach((option) => {
      option.state = false;
    });

    this.selectedChips = [];
    this.selectedValues.emit(this.selectedChips);
    return this.options;
  }

  setExistingValues(): void {
    this.subs.sink = timer(this.consts.SELECTED_CHIPS_TIMEOUT).subscribe(
      () => this.options.forEach((option) => {
        if (option.state) {
          this.selectedChips.push(option.value);
        }
      })
    )
  }
}
